export default "__VITE_ASSET__Cr5ZXp$I__"